<template>
    <div>
        <h2 class="text-center">รายการวางบิล</h2>
        <span style="display: none">{{checkbox_id}}</span>
        <template v-for="(receivable, index) in receivables_all" class="text-center">
            <template v-if="receivable.invoices.filter(invoice => invoice.active).length">
                <div class="row text-left">
                    <div class="col-7">
                        {{ receivable.customer_id }}
                        {{ receivable.store_name ? receivable.store_name : receivable.name  }}
                    </div>
                    <div class="col-2 text-right">
                        <label>ส่วนลด (%)</label>
                    </div>
                    <div class="col">
                        <input class="form-control w-50" placeholder="ส่วนลด %" v-model="receivable.discount"/>
                    </div>
                </div>
                <table class="table table-bordered text-center">
                    <thead>
                    <th>บิล</th>
                    <th>วันที่บิล</th>
                    <th>ยอดค้าง</th>
                    <th>กำหนดชำระ</th>
                    </thead>
                    <tbody>
                    <template v-for="(invoice, index) in receivable.invoices">
                        <template v-if="invoice.active">
                            <tr>
                                <td>{{ invoice.invoice_id }}</td>
                                <td>{{ invoice.date | moment("DD/MM/YYYY")}}</td>
                                <td>{{ invoice.remaining_payoff | currency }}</td>
                                <td>{{ invoice.due_date | moment("DD/MM/YYYY")}}</td>
                            </tr>
                        </template>
                    </template>
                    </tbody>
                </table>
            </template>
        </template>

        <div class="col text-center">
            <button @click="submitBilling"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button @click="cancelSubmit"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
<!--        <pre class="alert-primary text-left">{{receivables}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "billing-modal",
        data(){
          return{
              discount_type : [
                  {value:'1' ,text:'฿'},
                  {value:'2' ,text:'%'}
              ],
          }
        },
        computed:{
            ...mapState({
                receivables: state => {
                    return state.Receivable.receivables
                },
                receivables_all: state => {
                    return state.Receivable.receivables_all
                },
                checkbox_id:state=>{
                    return state.Receivable.checkbox_id
                },
                billing:state=>{
                    return state.Billing.create_billing
                }
            })
        },
        methods:{
            submitBilling(){
                this.$emit('submit', true);
            },
            cancelSubmit(){
                this.$emit('submit', false);
            }
        }
    }
</script>

<style scoped>

</style>
